<template>
  <div class="panel granary-right-panel">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/nccyData";
// import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {};
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getData();
  },
  methods: {
    getData() {
      // old data
      // const yearlist = ["2016", "2017", "2018", "2019"];
      // var data1 = [2298952, 2765584, 3057235, 2201054];
      // var data2 = [4000000, 4000000, 4000000, 4000000];

      get(
        "/api/dp/visual/queryList?code=syscqk&series=%E7%94%9F%E4%BA%A7"
      ).then(res => {
        const { item, data } = res;
        if (Array.isArray(data) && data.length > 0) {
          const _dt = data[0];
          let yearlist = [];
          let data1 = [];
          let data2 = [];
          item.forEach(e => {
            yearlist.push(e.name);
            data1.push(Number(_dt[e.code]));
            data2.push(4000000);
          });
          loadChart(this.chart, yearlist, data1, data2);
        }
      });
      // const yearlist = ["2022", "2021", "2022"];
      // var data1 = [2367728.78, 3315501.9, 3547242.34];
      // var data2 = [4000000, 4000000, 4000000];
      // loadChart(this.chart, yearlist, data1, data2);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
</style>
